import { InternshipAlgoliaApiQueryFilters } from 'algolia-api/types/AlgoliaApiQueryFilters';
import { mainInternshipsSearchRouteReference } from 'modules/main/main.routes';
import { HOME_PAGE_SLUGS } from 'utils/constants/general/homePageSlugs';

import { transformSearchFiltersToQueryParams } from './transformSearchFiltersToQueryParams';

type MainInternshipSearchRouteData = {
  lang: UserLocale;
  q: string;
  radius?: number | 'auto' | null;
  filters?: InternshipAlgoliaApiQueryFilters;
};

export function getMainInternshipsSearchRoutePath(
  data: MainInternshipSearchRouteData,
) {
  const { lang, filters, q, radius } = data;

  // Extract the segment based on type
  const segment = HOME_PAGE_SLUGS.INTERNSHIP[lang];

  let queryParams: { q: string; radius?: number | 'auto' } = {
    q,
  };

  if (radius) {
    queryParams = {
      ...queryParams,
      radius,
    };
  }

  if (filters) {
    // Merge basic and filter-derived query parameters
    queryParams = {
      ...queryParams,
      ...transformSearchFiltersToQueryParams(filters),
    };
  }

  return mainInternshipsSearchRouteReference.with({
    lang,
    segment,
    ...queryParams,
  });
}
